import React from "react";
import WhatWeLikeImage from "../Assets/what-we-like.png";

const WhatWeLike = ({ hideOnMobile }) => {
  return (
    <>
      <section
        className={hideOnMobile ? "d-none d-lg-block" : ""}
        id="section8"
      >
        <div className="what_we_like" id="what-we-like">
          <div className="what_we_like_bg">
            <div className="what_we_like_container">
              <div className="heading">
                <h3>
                  What <span>We Like</span>?
                </h3>
                <h5>Specialized Solutions for the Aviation Industry</h5>
                <p>
                  From pilot training modules to ground crew compliance courses,
                  we deliver industry-specific content that meets the highest
                  standards
                </p>
              </div>

              <div className="sec-feature">
                <h4>
                  Innovative ETraining solutions for pilots, ground staff, and
                  aviation professionals.
                </h4>
                <div className="fig">
                  <img src={WhatWeLikeImage} width={1000} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatWeLike;
